import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import NorLocale from 'date-fns/locale/nb';
import { addYears, addDays } from 'date-fns';
import {
  Dialog, DialogContent, DialogTitle, DialogActions,
  Button, MenuItem, FormControl, TextField, OutlinedInput,
  InputLabel, Typography,
} from '@material-ui/core';
import MuiSelect from '@material-ui/core/Select';
import { doFetch } from '../services/fetch/fetch.actions';
import { fetchCommitteesUsers } from '../services/admin/committee-service';
import Select from './select';
import * as userConstants from '../pages/admin/users/functions/constants';

class PoliticianDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: '',
      role: 'Ordfører',
      represents: '',
      fromDate: new Date(),
      toDate: addYears(new Date(), 4),
      minFrom: addYears(new Date(), -4),
      maxTo: addYears(new Date(), 8),
      note: '',
      userAlreadyAdded: false,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(doFetch(
      'COMMITTEE_ADD_USERS',
      fetchCommitteesUsers()
        .then((res) => {
          if (!res.ok) {
            throw res.statusText;
          }
          return res.json();
        }),
    ));
  }

  handleChange = (event) => {
    this.setState({ role: event.target.value });
  }

  render() {
    const {
      classes,
      currentUsers,
      committeesAddNames: { payload: { Resources: committeesAddNames } },
      open,
      handleClose,
      committee,
      handleSave,
      current,
      otherUsers,
    } = this.props;
    const {
      selected, role, represents, fromDate, toDate, minFrom, maxTo, note, userAlreadyAdded,
    } = this.state;

    const users = committeesAddNames ? committeesAddNames
      .filter(item => !currentUsers.some(obj => obj.value === item.id))
      .filter(item => item.roles && (item.roles.includes('politician') || item.roles.includes('secretary')
        || item.roles.includes('observatory') || item.roles.includes('other')))
      .filter(item => item.active === userConstants.ENABLED) : [];

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={NorLocale}>
        <Dialog
          open={open}
          className={classes.dialog}
          PaperProps={{ className: clsx(classes.dialog, classes.size) }}
        >
          <DialogTitle>
            {`Legg til medlem i ${committee}`}
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Select
              options={users.map(user => ({
                value: user.id,
                label: `${user.givenName} ${user.familyName}`,
                party: (user.parties && user.parties.length > 0) ? user.parties[0].display || user.parties[0].name : '',
              }))}
              onChange={(user) => {
                this.setState({ selected: user, represents: user.party || '', userAlreadyAdded: false });
                if (otherUsers.some(item => item.value === user.value)) {
                  const obj = otherUsers.find(item => item.value === user.value);
                  if (!current) {
                    this.setState({
                      minFrom: addDays(new Date(obj.to), 1),
                      fromDate: addDays(new Date(obj.to), 1),
                    });
                  } else {
                    this.setState({
                      maxTo: addDays(new Date(obj.from), -1),
                      toDate: addDays(new Date(obj.from), -1),
                    });
                  }
                } else {
                  this.setState({
                    minFrom: addYears(new Date(), -1),
                    maxTo: addYears(new Date(), 8),
                  });
                }
              }}
              placeholder="Navn&thinsp;*"
            />
            {userAlreadyAdded && (
              <div className={classes.alert}>
                <Typography color="inherit" variant="body1">
                  Det valgte medlemmet er allerede lagt til i dette utvalget.
                </Typography>
              </div>
            )}
            <FormControl variant="outlined" className={classes.role}>
              <InputLabel className={classes.label} required>Stilling</InputLabel>
              <MuiSelect
                variant="outlined"
                value={role}
                onChange={this.handleChange}
                displayEmpty
                className={classes.select}
                input={<OutlinedInput labelWidth={56} name="par" />}
              >
                <MenuItem value="Ordfører">Ordfører</MenuItem>
                <MenuItem value="Varaordfører">Varaordfører</MenuItem>
                <MenuItem value="Leder">Leder</MenuItem>
                <MenuItem value="Nestleder">Nestleder</MenuItem>
                <MenuItem value="Byrådsleder">Byrådsleder</MenuItem>
                <MenuItem value="Byrådsnestleder">Byrådsnestleder</MenuItem>
                <MenuItem value="Byråd">Byråd</MenuItem>
                <MenuItem value="Byrådssekretær">Byrådssekretær</MenuItem>
                <MenuItem value="Medlem">Medlem</MenuItem>
                <MenuItem value="Varamedlem">Varamedlem</MenuItem>
                <MenuItem value="Sekretær">Sekretær</MenuItem>
                <MenuItem value="Observatør">Observatør</MenuItem>
              </MuiSelect>
            </FormControl>
            <TextField
              className={clsx(classes.role, classes.label)}
              variant="outlined"
              label="Representerer (valgfritt)"
              onChange={e => this.setState({ represents: e.target.value })}
              value={represents}
            />
            <TextField
              className={clsx(classes.role, classes.label)}
              variant="outlined"
              label="Merknad (valgfritt)"
              onChange={e => this.setState({ note: e.target.value })}
              value={note}
            />
            <KeyboardDatePicker
              className={clsx(classes.label, classes.datepicker, classes.mr)}
              value={fromDate}
              placeholder="dd.mm.yyyy"
              onChange={val => this.setState({ fromDate: val })}
              format="dd.MM.yyyy"
              inputVariant="outlined"
              required
              minDate={minFrom}
              label="Fra"
            />
            <KeyboardDatePicker
              className={clsx(classes.label, classes.datepicker)}
              value={toDate}
              placeholder="dd.mm.yyyy"
              onChange={val => this.setState({ toDate: val })}
              format="dd.MM.yyyy"
              inputVariant="outlined"
              required
              label="Til"
              maxDate={maxTo}
              minDate={fromDate}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose}>
              Avbryt
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={role === '' || selected === ''}
              onClick={() => {
                this.setState({ selected: '', represents: '' });
                if (!handleSave(selected, role, represents, note, fromDate, toDate)) {
                  this.setState({ userAlreadyAdded: true });
                }
              }}
            >
              Legg til
            </Button>
          </DialogActions>
        </Dialog>
      </MuiPickersUtilsProvider>
    );
  }
}

PoliticianDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  currentUsers: PropTypes.any,
  committeesAddNames: PropTypes.any.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  committee: PropTypes.string.isRequired,
  handleSave: PropTypes.func,
  current: PropTypes.bool,
  otherUsers: PropTypes.array,
};

PoliticianDialog.defaultProps = {
  currentUsers: [],
  handleClose: () => {},
  handleSave: () => {},
  otherUsers: [],
  current: false,
};

const styles = theme => ({
  size: {
    minHeight: '12rem',
    [theme.breakpoints.up('sm')]: {
      minWidth: '25rem',
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '17rem',
    },
  },
  dialogContent: {
    overflow: 'visible',
  },
  dialog: {
    overflow: 'visible',
  },
  secondary: {
    color: 'rgba(0, 0, 0, 0.54)',
    paddingBottom: '1rem',
  },
  primary: {
    paddingTop: '1.5rem',
  },
  role: {
    marginTop: '1.5rem',
    width: '100%',
  },
  select: {
    paddingLeft: '2px',
  },
  label: {
    zIndex: 0,
  },
  datepicker: {
    marginTop: '1.5rem',
    width: '12rem',
  },
  mr: {
    marginRight: '1.5rem',
  },
  alert: {
    backgroundColor: 'rgb(255, 244, 229)',
    color: 'rgb(102, 60, 0)',
    padding: '1rem',
    maxWidth: '60rem',
    marginTop: '1rem',
    borderRadius: '4px',
    display: 'flex',
  },
});

const mapStateToProps = ({ committeesAddNames }) => ({ committeesAddNames });

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(PoliticianDialog));
